import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SecureURLComponent } from './secure-url/secure-url.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'business',
    loadChildren: () => import('./landing-business/landing-business.module').then(m => m.LandingBusinessModule)
  },
  {
    path: 'cambix',
    loadChildren: () => import('./cambix/cambix.module').then(m => m.CambixModule)
  },
  {
    path: 'cambix-business',
    loadChildren: () => import('./cambix-business/cambix-business.module').then(m => m.CambixBusinessModule)
  },
  {
    path: 'secure-redirect',
    component: SecureURLComponent
  },
  {
    path: '**', redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
